/**
 * @name 组件属性设置统一管理
 * @description 组件属性设置采用动态组件方式，该配置文件内容不需要暴露出来，
 *              只做动态组件指向性内容时用到，所以将此抽离
 * @function searchItemConfig 查询组件配置项方法
 * @author liuguisheng
 * @version 2019-09-24
 * 
*/

/**
 * 
 *                   组件设置配置目录    （注意: 如果添加新的设置项，请及时更新此目录）
 * 
 *                    组件基础设置
 * 
 * setting-custom-name.........................自定义名称
 * setting-title...............................标题
 * setting-placeholder.........................提示语
 * 
 * setting-is-clearable........................是否可清空
 * setting-is-disabled.........................是否禁用
 * setting-is-editable.........................是否可输入
 * setting-is-readonly.........................是否只读
 * 
 * setting-autosize............................文本域最大行数和最小行数
 * setting-event...............................关联设置
 * setting-display-type........................布局方式（单行/多行）
 * setting-options.............................选项设置
 * setting-select-multiple.....................是否多选
 * setting-variable............................变量设置
 * setting-validator-rule..........................表单校验
 * 
 * setting-date-type...........................日期显示类型
 * setting-date-format.........................日期格式
 * setting-date-filter.........................日期过滤
 * 
 * setting-line-text...........................分割线文字
 * setting-line-text-position..................分割线文本位置
 * setting-line-style..........................分割线位置
 * 
 * setting-upload-limit........................上传个数限制
 * setting-upload-config.......................上传配置（上传地址、上传目录等）
 * 
 * setting-grid-gutter.........................栅格间隔
 * setting-grid-columns........................栅格列配置
 * setting-grid-align..........................栅格垂直排列方式
 * setting-grid-justify........................栅格水平排列方式
 * 
 * 
 * 
 *                   组件样式设置
 * 
 * setting-label-position......................标签位置
 * setting-label-text-position.................标签文本对齐方式
 * setting-label-width.........................标签宽度
 * setting-style-class.........................自定义class
 * setting-style-width.........................组件宽度
 * setting-style-height........................组件高度
 * setting-text-width..........................文字组件宽度
 * setting-text-color..........................文字颜色设置
 * setting-style-paddingleft...................左间距
 * 
 * 
 *                   模板样式设置
 * 
 * render-strong.......................加粗
 * render-underline....................下划线
 * render-italic.......................斜体
 * render-wrap.........................换行
 * render-line-height..................行高
 * render-indent.......................首行缩进
 * render-text-underline...............文字组件下划线
 * render-show.........................展示配置
 * render-seat.........................透明占位
 * render-color........................渲染颜色
 * render-is-underline.................是否添加下划线
 * 
*/

const settingItemsObj = {
    // 文字
    text: { 
        baseSetting: [
            'setting-custom-name',
            'setting-content'
        ],
        styleSetting: [
            'setting-style-class',
            'setting-text-width',
            'setting-text-title',
            'setting-text-color',
            'setting-style-paddingleft'
        ],
        renderSetting: [
            'render-color',
            'render-strong',
            'render-text-underline',
            'render-italic',
            'render-wrap',
            'render-indent',
            'render-font-size',
            'render-align',
            'render-line-height',
            'render-show',
            'render-seat'
        ]
    },
    // 按钮
    button: {
        baseSetting: [
            'setting-custom-name',
            'setting-button-type',
            'setting-button-back',
            'setting-button-size',
            'setting-button-text',
            'setting-button-loading',
            'setting-button-throttle',
            'setting-event'
        ],
        styleSetting: [
            'setting-style-class',
            'setting-style-width',
            'setting-style-paddingleft'
        ],
        renderSetting: []
    },
    // 单行文本
    input: {
        baseSetting: [
            'setting-custom-name',
            'setting-title',
            'setting-placeholder',
            'setting-is-clearable',
            'setting-is-disabled',
            'setting-validator-rule',
            'setting-event',
            'setting-variable'
        ],
        styleSetting: [
            'setting-style-class',
            'setting-style-width',
            'setting-label-position', 
            'setting-label-text-position',
            'setting-label-width',
            'setting-style-paddingleft'
        ],
        renderSetting: [
            'render-color',
            'render-strong',
            'render-is-underline',
            'render-underline',
            'render-italic',
            'render-wrap',
            'render-indent',
            'render-line-height',
            'render-show',
            'render-seat',
            'render-null-render'
        ]
    },
    // 多行文本
    textarea: {
        baseSetting: [
            'setting-custom-name',
            'setting-title',
            'setting-placeholder',
            'setting-is-clearable',
            'setting-is-disabled',
            'setting-autosize',
            'setting-validator-rule',
            'setting-event',
            'setting-variable'
        ],
        styleSetting: [
            'setting-style-class',
            'setting-style-width',
            'setting-label-position', 
            'setting-label-text-position',
            'setting-label-width',
            'setting-style-paddingleft'
        ],
        renderSetting: [
            'render-color',
            'render-strong',
            'render-is-underline',
            'render-underline',
            'render-italic',
            'render-wrap',
            'render-indent',
            'render-line-height',
            'render-show',
            'render-seat',
            'render-null-render'
        ]
    },
    // 单选框组
    radio: {
        baseSetting: [
            'setting-custom-name',
            'setting-title',
            'setting-display-type',
            'setting-options',
            'setting-is-disabled',
            'setting-validator-rule',
            'setting-event'
        ],
        styleSetting: [
            'setting-style-class',
            'setting-label-position', 
            'setting-label-text-position',
            'setting-label-width',
            'setting-style-paddingleft'
        ],
        renderSetting: [
            'render-color',
            'render-strong',
            'render-is-underline',
            'render-underline',
            'render-italic',
            'render-wrap',
            'render-indent',
            'render-line-height',
            'render-show',
            'render-null-render'
        ]
    },
    // 多选框组
    checkbox: {
        baseSetting: [
            'setting-custom-name',
            'setting-title',
            'setting-display-type',
            'setting-options',
            'setting-is-disabled',
            'setting-validator-rule',
            'setting-event'
        ],
        styleSetting: [
            'setting-style-class',
            'setting-label-position', 
            'setting-label-text-position',
            'setting-label-width',
            'setting-style-paddingleft'
        ],
        renderSetting: [
            'render-color',
            'render-strong',
            'render-is-underline',
            'render-underline',
            'render-italic',
            'render-wrap',
            'render-line-height',
            'render-indent',
            'render-line-height',
            'render-show',
            'render-null-render'
        ]
    },
    // 下拉选择器
    select: {
        baseSetting: [
            'setting-custom-name',
            'setting-title',
            'setting-placeholder',
            'setting-select-multiple',
            'setting-options',
            'setting-is-clearable',
            'setting-is-disabled',
            'setting-validator-rule',
            'setting-event'
        ],
        styleSetting: [
            'setting-style-class',
            'setting-style-width',
            'setting-label-position', 
            'setting-label-text-position',
            'setting-label-width',
            'setting-style-paddingleft'
        ],
        renderSetting: [
            'render-color',
            'render-strong',
            'render-underline',
            'render-italic',
            'render-wrap',
            'render-indent',
            'render-line-height',
            'render-show'
        ]
    },
    // 滑块
    switch: {
        baseSetting: [
            'setting-custom-name',
            'setting-title',
            'setting-is-disabled',
            'setting-event'
        ],
        styleSetting: [
            'setting-style-class',
            'setting-style-width',
            'setting-label-position', 
            'setting-label-text-position',
            'setting-label-width',
            'setting-style-paddingleft'
        ],
        renderSetting: [
            'render-color',
            'render-strong',
            'render-underline',
            'render-italic',
            'render-wrap',
            'render-indent',
            'render-line-height',
            'render-show'
        ]
    },
    // 日期选择器
    datePicker: {
        baseSetting: [
            'setting-custom-name',
            'setting-title',
            'setting-placeholder',
            'setting-date-type',
            'setting-date-format',
            'setting-date-filter',
            'setting-is-readonly',
            'setting-is-disabled',
            'setting-is-clearable',
            'setting-validator-rule',
            'setting-event'
        ],
        styleSetting: [
            'setting-style-class',
            'setting-style-width',
            'setting-label-position', 
            'setting-label-text-position',
            'setting-label-width',
            'setting-style-paddingleft' 
        ],
        renderSetting: [
            'render-color',
            'render-strong',
            'render-underline',
            'render-italic',
            'render-wrap',
            'render-indent',
            'render-line-height',
            'render-show'
        ]
    },
    // 时间选择器
    timePicker: {
        baseSetting: [
            'setting-custom-name',
            'setting-title',
            'setting-placeholder',
            'setting-is-readonly',
            'setting-is-disabled',
            'setting-is-clearable',
            'setting-validator-rule',
            'setting-event'
        ],
        styleSetting: [
            'setting-style-class',
            'setting-style-width',
            'setting-label-position', 
            'setting-label-text-position',
            'setting-label-width',
            'setting-style-paddingleft'
        ],
        renderSetting: [
            'render-color',
            'render-strong',
            'render-underline',
            'render-italic',
            'render-wrap',
            'render-indent',
            'render-line-height',
            'render-show'
        ]
    },
    // 分割线
    line: {
        baseSetting: [
            'setting-custom-name',
            'setting-line-text',
            'setting-line-text-position',
            'setting-line-style'
        ],
        styleSetting: [
            'setting-style-class',
            'setting-style-width',
            'setting-style-height',
            'setting-style-paddingleft'
        ],
        renderSetting: []
    },
    // 上传图片
    uploadImage: {
        baseSetting: [
            'setting-custom-name',
            'setting-title',
            'setting-upload-limit',
            'setting-upload-config',
            'setting-validator-rule'
        ],
        styleSetting: [
            'setting-label-position', 
            'setting-label-text-position',
            'setting-label-width',
            'setting-style-paddingleft'
        ],
        renderSetting: [
            'render-strong',
            'render-underline',
            'render-italic',
            'render-wrap',
            'render-indent',
            'render-show'
        ]
    },
    // 上传文件
    uploadFile: {
        baseSetting: [
            'setting-custom-name',
            'setting-title',
            'setting-upload-limit',
            'setting-upload-config',
            'setting-validator-rule'
        ],
        styleSetting: [
            'setting-label-position', 
            'setting-label-text-position',
            'setting-label-width',
            'setting-style-paddingleft'
        ],
        renderSetting: [
            'render-strong',
            'render-underline',
            'render-italic',
            'render-wrap',
            'render-indent',
            'render-show'
        ]
    },
    // 栅格布局
    grid: {
        baseSetting: [
            'setting-custom-name',
            'setting-grid-gutter',
            'setting-grid-columns',
            'setting-grid-align',
            'setting-grid-justify'
        ],
        styleSetting: [
            'setting-style-paddingleft'
        ],
        renderSetting: []
    },
    // 任意门
    free: {
        baseSetting: [
            'setting-custom-name'
        ],
        styleSetting: [
            'setting-style-paddingleft'
        ],
        renderSetting: []
    }
}


/**
 * @name 查询组件配置项方法
 * @param { String } type 组件类型
 * @param { String } attribute 属性类型  ex: // baseSetting 组件基础设置    
 *                                          // styleSetting 组件样式设置
 *                                          // renderSetting 渲染设置
 * @author  liuguisheng
 * @version 2019-9-24
*/

export const searchItemConfig = ( type , attribute  ) => {
    // 接收组件类型和需要设置的属性，遍历上述配置文件，如果类型一样，返回对应值，否则返回空数组
    for( let i in settingItemsObj ) {
        if( i == type ) return settingItemsObj[type][attribute];
    };
    return []
}


// WEBPACK FOOTER //
// ./src/assets/js/item_attribute_config.js